import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import { MainImageContainer } from '../../containers/MainImage';
import { FavoriteEntityControlsBarContainer } from '../../containers/FavoriteEntityControlsBar';
import { CommentSection } from '../CommentSection';
import { Address } from '../Address';
import { Undergrounds } from '../Undergrounds';
import { Agent } from '../Agent';
import { Description } from '../Description';
import { FavoriteInfo } from '../FavoriteInfo';
import { AreaParts } from '../AreaParts';
import { IFavoriteEntity } from '../../types/results';

import * as styles from './FavoriteEntity.css';

export interface IFavoriteEntityOwnProps {
  favoriteEntity: IFavoriteEntity;
  isEditComment: boolean;
  isFetchingComment: boolean;
  isHideForPrint: boolean;
  printComments: boolean;
  checkbox: React.ReactNode | null;
}

export type TFavoriteEntityProps = IFavoriteEntityOwnProps;

export const ONE_LINE_HEIGHT = 20;

export class FavoriteEntity extends React.Component<TFavoriteEntityProps> {
  private htmlDescription: HTMLDivElement | null = null;

  public componentDidMount() {
    /**
     * Убираем градиент у однострочных и двустрочных описание.
     * На третьей строке отображаем градиент всегда.
     */
    if (this.htmlDescription) {
      const { scrollHeight } = this.htmlDescription;

      if (scrollHeight === ONE_LINE_HEIGHT || scrollHeight === ONE_LINE_HEIGHT * 2) {
        this.htmlDescription.classList.add(styles['description--no-gradient']);
      }
    }
  }

  public render() {
    const { favoriteEntity, isHideForPrint, printComments, isEditComment, isFetchingComment, checkbox } = this.props;
    const { entityId, note, geo, description, agentInfo, fullUrl } = favoriteEntity;
    const areaParts = favoriteEntity.commercialInfo && favoriteEntity.commercialInfo.areaParts;

    return (
      <div {...mergeStyles(styles['container'], isHideForPrint && styles['hide_print'])}>
        <div className={styles['row']}>
          {checkbox && <div className={styles['checkbox']}>{checkbox}</div>}
          <div className={styles['image']}>
            <MainImageContainer favoriteEntity={favoriteEntity} />
          </div>
          <div className={styles['main_content']}>
            <div className={styles['info']}>
              <div>
                <div className={styles['info_top']}>
                  <FavoriteInfo favoriteEntity={favoriteEntity} />
                </div>
                <div className={styles['geo_info']}>
                  {geo && <Undergrounds undergrounds={geo.undergrounds} />}
                  {geo && <Address address={geo.address} />}
                </div>
                <div
                  {...mergeStyles(
                    styles['description'],
                    areaParts && areaParts.length > 0 && styles['description-with-areaParts'],
                  )}
                  ref={div => (this.htmlDescription = div)}
                >
                  {description && <Description description={description} />}
                </div>
                {areaParts && areaParts.length > 0 && (
                  <AreaParts areaParts={areaParts} entityId={entityId} fullUrl={fullUrl} />
                )}
              </div>

              <FavoriteEntityControlsBarContainer favoriteEntity={favoriteEntity} />
            </div>
            <div className={styles['agent']}>{agentInfo && <Agent agentInfo={agentInfo} />}</div>
          </div>
        </div>

        <div {...mergeStyles(styles['row'], !printComments && styles['hide_print'])}>
          {(note || isEditComment) && (
            <CommentSection
              editable={isEditComment}
              comment={note}
              entityId={entityId}
              isFetching={isFetchingComment}
            />
          )}
        </div>
      </div>
    );
  }
}
